/*
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-11 16:26:39
 */
import axios from "axios";
import { get, post } from "./base";

const LOGIN_URL = "/AccountRest/login";
const LOGOUT_URL = "/AccountRest/logout";
const REGISTER_URL = "/AccountRest/saveRegister";
const TOKEN_REFRESH_URL = "AccountRest/token/refresh";
const GET_SCHOOL_URL = "/AccountRest/getSchools";
const GET_SCHOOL_ID = "/AccountRest/getSchoolId";
const LICENSE_URL="/license";
const TICK_CHECK_URL="/AccountRest/check/tick"
const AFFICHE_URL = "/affiche/open";

class Account {
    static login(form) {
        return axios.post(LOGIN_URL, { userName: form.userName, password: form.password });
    }
    static logout() {
        return axios.post(LOGOUT_URL);
    }
    static refreshToken(refreshToken) {
        return axios.get(`${TOKEN_REFRESH_URL}?refreshId=${refreshToken}`);
    }
    static refresh() {
        return axios.post("/HomeRest/refresh");
    }
    static getSchool() {
        return axios.get(GET_SCHOOL_URL);
    }
    static hasSelectedCourse() {
        return axios.get("/HomeRest/hasSelectedCourse");
    }
    static saveRegister(form) {
        return axios.post(REGISTER_URL, form);
    }

    static updateUser(form) {
        return axios.post("/HomeRest/updateUserInfo", form);
    }
    static changePassword(form) {
        return axios.post("/HomeRest/changePassword", form);
    }

    static forceChangePassword(form) {
        return axios.post("/HomeRest/forceChangePassword", form);
    }

    static getSessionMap(){
        return axios.get("/AccountRest/sessions");
    }

    static uploadUserImage(data) {
        return axios.post("/HomeRest/postUserImage",data);
    }

    static saveUserImage(data) {
        return axios.post("/HomeRest/saveUserImage",data);
    }

    static checkTick(){
        return axios.get(TICK_CHECK_URL);
    }
    static checkPermission(data){
        return axios.post("/AccountRest/permission",data);
    }
    static getSchoolId(){
        return axios.get(GET_SCHOOL_ID);
    }
}
export default Account;
export {
    LOGIN_URL,
    REGISTER_URL,
    TOKEN_REFRESH_URL
}
